import React from "react";

import './ApplicationPageWrapper.scss' ;
import ButtonBar from "@estar/Components/Common/ButtonBar/ButtonBar";

const ApplicationPageWrapper = ({children, title, subtitle, buttonDefs=[]}) =>
{
    const subtitleDiv = () =>
    {
        if ( subtitle === undefined )
        {
            if ( buttonDefs.length !== 0 )
            {
                return (
                    <div className='page-subtitle'>
                        <div className="home-page-intro"></div>
                        <div className='home-page-buttonbar'><ButtonBar buttonDefs={buttonDefs} /></div>
                    </div>
                )
            }
        }
        else
        {
            return (
                <div className='page-subtitle'>
                    <div className="home-page-intro">{subtitle}</div>
                    <div className='home-page-buttonbar'><ButtonBar buttonDefs={buttonDefs} /></div>
                </div>
            )
        }
    }

    return (
        <div className='estar-home-page'>
            <h3 className="home-page-teacher-header">{title}</h3>
            { subtitleDiv() }
            {children}
        </div>
    )
}

export default  ApplicationPageWrapper ;
